import React from 'react';
import ScoreboardHouseSelectTab from './ScoreboardHouseSelectTab';
import ScoreboardHouseCarouselTab from './ScoreboardHouseCarouselTab';

const ScoreboardHouse = ({ filters = [], onFilterChange, activeFilterId }) => {

    return (
        filters?.length > 3 ?
            <ScoreboardHouseSelectTab
                filters={filters}
                onFilterChange={onFilterChange}
                activeFilterId={activeFilterId}
            />
            :
            <ScoreboardHouseCarouselTab
                filters={filters}
                onFilterChange={onFilterChange}
                activeFilterId={activeFilterId}
            />

    );
};

export default ScoreboardHouse;
